import { render } from "./UserStores.vue?vue&type=template&id=3276b8ae&scoped=true"
import script from "./UserStores.vue?vue&type=script&lang=js"
export * from "./UserStores.vue?vue&type=script&lang=js"

import "./UserStores.vue?vue&type=style&index=0&id=3276b8ae&lang=scss"
import "./UserStores.vue?vue&type=style&index=1&id=3276b8ae&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3276b8ae"]])

export default __exports__